module.exports = __webpack_public_path__ + "static/media/datahub-overview.39398ca3.png";